(() => {
  function updateVideoButtonState(button, video) {
    const icon = button.querySelector('.video-sound-toggle__icon');
    const text = button.querySelector('.video-sound-toggle__text');
    const isMuted = !!video.muted;

    button.setAttribute('aria-label', isMuted ? 'Enable sound' : 'Mute sound');

    if (icon) icon.textContent = isMuted ? '🔊' : '🔇';
    if (text) text.textContent = isMuted ? 'Tap for sound' : 'Tap to mute';
  }

  function initMatchReady(scope = document) {
    scope.querySelectorAll('.match-ready-reveal').forEach((element) => {
      element.classList.add('is-visible');
    });

    scope.querySelectorAll('.video-sound-toggle').forEach((button) => {
      if (button.dataset.mrBound === 'true') return;

      const wrap = button.closest('.match-ready-video-wrap');
      const video = wrap ? wrap.querySelector('video') : null;
      if (!video) return;

      button.dataset.mrBound = 'true';
      updateVideoButtonState(button, video);

      button.addEventListener('click', () => {
        video.muted = !video.muted;
        updateVideoButtonState(button, video);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMatchReady(document));
  } else {
    initMatchReady(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initMatchReady(event.target);
  });
})();
